module.exports = __webpack_public_path__ + "img/parked.b489cf6f.svg";